/*
 * Copyright (c) 2021. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import LpOnlineDivorceMeta from "./LpOnlineDivorceMeta";
import Layout from "../../../../Layouts/Layout";
import Container from "../../../../../components/Container/Container";
import DivorceCheckin from "../../../../../components/Checkin/DivorceCheckin/DivorceCheckin";
import { landingPagesList } from "../../../../../services/landingPagesList";
import { getLastPathSplit } from "../../../../../services/redirect";
import ProcedureDivorceSection from "../../../../../components/Sections/Divorce/ProcedureDivorceSection/ProcedureDivorceSection";
import AdvantagesLegalbirdAttorneySection from "../../../../../components/Sections/Generic/AdvantagesLegalbirdAttorneySection/AdvantagesLegalbirdAttorneySection";
import DivorceHighlightBox from "../../../../../components/Sections/Divorce/KindsOfDivorceSection/DivorceHighlightBox";
import DivorcePlannerSection from "../../../../../components/Sections/Divorce/DivorcePlannerSection/DivorcePlannerSection";
import TrustSection from "../../../../../components/Sections/Generic/TrustSection/TrustSection";
import LandingPageTeaser from "../../../../../components/Teaser/LandingPageTeaser";
import ServiceSection from "../../../../../components/Sections/Generic/ServiceSection/ServiceSection";
import TeamSection from "../../../../../components/Sections/Generic/TeamSection/TeamSection";
import BirdMapSection from "../../../../../components/Sections/Divorce/BirdMapSection/BirdMapSection";
import PartnersSection from "../../../../../components/Sections/Generic/PartnersSection/PartnersSection";
import ServiceTeaser from "../../../../../components/Teaser/ServiceTeaser";
import { divorceTeaserCards } from "../../../../../services/landingPageService";
import GreyBackgroundWrapper from "../../../../../components/BackgroundWrapper/GreyBackgroundWrapper";
import LinkedCardBox from "../../../../../components/LinkedCardBox/LinkedCardBox";
import { useLocation } from "react-router";
import { useCustomer } from "../../../../../provider/Customer/CustomerProvider";

export default function LpOnlineDivorce() {
  const location = useLocation();
  const lpKey = getLastPathSplit(location.pathname);
  const keyword = (lpKey && landingPagesList[lpKey]?.keyword) ?? "Online Scheidung";
  const headline = (lpKey && landingPagesList[lpKey]?.keyword) ?? "Online Scheidung einfach & günstig";

  const { isLoggedIn } = useCustomer();

  return (
    <Layout minimal={!isLoggedIn} clickableLogo={isLoggedIn} backgroundType={"landingpage"}>
      <LpOnlineDivorceMeta keyword={keyword} />
      <LandingPageTeaser
        headline={headline}
        subheadline={"Wir begleiten Sie sicher bei Ihrer Scheidung."}
        teaserButtonLink={isLoggedIn ? "/servicewelt" : "#top-checkin"}
      >
        <LinkedCardBox linkedCards={divorceTeaserCards} />
      </LandingPageTeaser>
      <GreyBackgroundWrapper>
        {!isLoggedIn && (
          <Container>
            <DivorceCheckin idPrefix={"top"} checkinHeading={"Wir führen Sie Schritt für Schritt durch Ihre Scheidung"} />
          </Container>
        )}
        <ServiceSection product={"divorce"} />
      </GreyBackgroundWrapper>
      <TeamSection isSubsection={true} />
      <BirdMapSection />
      <GreyBackgroundWrapper>
        <AdvantagesLegalbirdAttorneySection />
        <ServiceTeaser />
      </GreyBackgroundWrapper>
      <DivorcePlannerSection />
      <GreyBackgroundWrapper>
        <ProcedureDivorceSection />
        <Container>
          <DivorceHighlightBox />
        </Container>
      </GreyBackgroundWrapper>
      <TrustSection />
      {!isLoggedIn && (
        <Container>
          <DivorceCheckin idPrefix="bottom" />
        </Container>
      )}
      <PartnersSection />
    </Layout>
  );
}
